// extracted by mini-css-extract-plugin
export var base = "_18-0";
export var updateBanner = "_18-1";